import HomeContainer from './HomeContainer'

// export {default as ApprovePos}
export default HomeContainer